// Constants.
import * as CouponsConstants from 'constants/CouponsConstants';
import * as AuthConstants from 'constants/AuthConstants';
import * as ErrorConstants from 'constants/ErrorConstants';

const initialState = {
  isFetching: false,
  isFetched: false,
  coupons: {},
  errorMessage: '',
};

export default function coupons(state = initialState, action = {}) {
  switch (action.type) {
    case CouponsConstants.LOAD_COUPONS_REQUEST:
      return {
        ...state,
        isFetched: false,
        isFetching: true,
      };
    case CouponsConstants.LOAD_COUPONS_SUCCESS: {
      const coupons = { ...state.coupons };
      return {
        ...state,
        isFetched: true,
        isFetching: false,
        coupons: action.coupons,
      };
    }
    case CouponsConstants.LOAD_COUPONS_FAILURE:
      return {
        ...state,
        isFetched: false,
        isFetching: false,
        coupons: {},
        errorMessage: action.message,
      };
    case AuthConstants.LOGOUT_SUCCESS:
    case AuthConstants.LOGOUT_TOKEN_SUCCESS:
    case ErrorConstants.LOAD_REQUEST_FAILURE:
    case CouponsConstants.LOAD_COUPONS_CLEAR:
      return {
        ...state,
        isFetched: false,
        isFetching: false,
        coupons: {},
        errorMessage: '',
      };
    default:
      return state;
  }
}
